import React from "react";
import { Button, Flex, Form, Input } from "@payping/web-components";
import { useAppTranslation } from "@/utils/useAppTranslation";
import styles from "../../../../assets/scss/profile/Profile.module.scss";
import { InformationSection } from "./InformationSection";
import { createIbanValidator } from "../utils/ibanValidation";

interface SingleIBANFormProps {
  form: any;
  onFinish: (values: { title: string; iban: string }) => void;
  onFormValuesChange: (changedValues: any, allValues: any) => void;
  isFormValid: boolean;
  isLoading: boolean;
  isEditing?: boolean;
  onCancel: () => void;
}

export const SingleIBANForm: React.FC<SingleIBANFormProps> = ({
  form,
  onFinish,
  onFormValuesChange,
  isFormValid,
  isLoading,
  isEditing = false,
  onCancel,
}) => {
  const { t } = useAppTranslation();

  return (
    <div className="tw-py-4">
      <Form form={form} layout="vertical" onFinish={onFinish} onValuesChange={onFormValuesChange}>
        <Form.Item
          label={t("profile.bank.title")}
          name="title"
          rules={[{ required: true, message: t("profile.bank.titleRequired") }]}
          className="tw-mb-6"
        >
          <Input placeholder={t("profile.bank.titlePlaceholder")} className="tw-h-12" />
        </Form.Item>

        <Form.Item
          label={t("profile.bank.ibanNumber")}
          name="iban"
          rules={[
            { required: true, message: t("profile.bank.ibanRequired") },
            {
              validator: createIbanValidator(t),
            },
          ]}
          className="tw-mb-6"
        >
          <Input
            className={`${styles.inputLtr} tw-h-12`}
            suffix="IR"
            placeholder={t("profile.bank.ibanPlaceholder")}
            onlyNumbers
            canStartWithZero
          />
        </Form.Item>

        <InformationSection />

        <Flex gap="12px" className="tw-w-full md:tw-justify-end">
          <Button
            type="primary"
            htmlType="submit"
            className="w-full md:tw-min-w-20"
            loading={isLoading}
            disabled={!isFormValid || isLoading}
          >
            {isEditing ? t("profile.bank.edit") : t("profile.bank.save")}
          </Button>
          <Button onClick={onCancel} className="w-full md:tw-min-w-20" disabled={isLoading}>
            {t("profile.bank.cancel")}
          </Button>
        </Flex>
      </Form>
    </div>
  );
};

